var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailcompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#C20101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1765 8.43367C17.5671 8.04314 17.5671 7.40998 17.1765 7.01946C16.786 6.62893 16.1528 6.62893 15.7623 7.01946L12.098 10.6838L8.43367 7.01946C8.04314 6.62893 7.40998 6.62893 7.01946 7.01946C6.62893 7.40998 6.62893 8.04314 7.01946 8.43367L10.6838 12.098L7.01946 15.7623C6.62893 16.1528 6.62893 16.786 7.01946 17.1765C7.40998 17.5671 8.04314 17.5671 8.43367 17.1765L12.098 13.5122L15.7623 17.1765C16.1528 17.5671 16.786 17.5671 17.1765 17.1765C17.5671 16.786 17.5671 16.1528 17.1765 15.7623L13.5122 12.098L17.1765 8.43367Z",
    fill: "#C20101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailcompliance);
export default __webpack_public_path__ + "static/media/failcompliance.18d885bb2aaa5959bab082189707e75f.svg";
export { ForwardRef as ReactComponent };